import useAppSelector from "stores/useAppSelector";
const useViewsSelector = (fn) => useAppSelector(fn);
export default useViewsSelector;
